import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  RadioGroup,
  Radio,
  Typography,
  FormControl,
  FormControlLabel,
  FormLabel,
  Table,
  TableHead,
  TableBody,
  TablePagination,
  TableRow,
  TableCell,
  TableContainer,
  Tab,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Loader, Select } from 'sputnik-ui'
import { fetchPayoutLicensedKeyInfos } from 'store/analytics/payoutSlice'

export function SalesTable({ 
  Wrapper, 
  formatDate, 
  StartEndDatesComponent,
  setLocalityFilter,
  localities,
  localityFilter,
  minDate,
  visualFormatDate,
  selectedCompanyUuid
  }) {
  const [startDate, setStartDate] = useState(minDate)
  const [endDate, setEndDate] = useState(formatDate(new Date()))
  const formatSetDate = (setter, e) => {
    setter(formatDate(e.target.value))
  }
  const [localityUuid, setLocalityUuid] = useState()
  const dispatch = useDispatch()
  const { t } = useTranslation(['analytics'])
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(30)
  const kinds = [ {
      label: t('analytics:licensed_keys.all'),
      value: 'all'
    },
    {
      label:t("analytics:licensed_keys.unblocked"),
      value: 'activated'
    },
    {
      label: t("analytics:licensed_keys.blocked"),
      value: 'blocked'
    },
    {
      label: t("analytics:licensed_keys.deleted"),
      value: 'deleted'
    }
  ]
  const [kind, setKind] = useState(kinds[0])

  const displayState = (blocked, deleted) => {
    if (deleted) {
      return t("analytics:licensed_keys.deleted")
    }

    if (blocked) {
      return t("analytics:licensed_keys.blocked")
    }

    return t("analytics:licensed_keys.unblocked")
  }

  useEffect(() => {
    const date = new Date()
    const startDateFormatted = startDate === 'NaN-NaN-NaN' ? minDate : startDate
    const monthNormalized = date.getMonth()
    const endDateFormatted = endDate === 'NaN-NaN-NaN' ? formatDate(`${date.getFullYear()}-${monthNormalized}-01`) : endDate
    dispatch(fetchPayoutLicensedKeyInfos({
      startDate: startDateFormatted, 
      endDate: endDateFormatted, 
      page, 
      limit, 
      kind: kind.value, 
      locality_uuid: localityUuid,
      company_uuid: selectedCompanyUuid,
    }))
  }, [dispatch, startDate, endDate, page, limit, kind, localityUuid, selectedCompanyUuid])

  const keysSalesInfo  = useSelector(({ payoutSlice }) => payoutSlice.payout_licensed_keys_info);

  if (keysSalesInfo === null) {
    return <Loader />
  }

  return (
    <>
      <Wrapper style={{
        display: 'flex',
        flexDirection: 'column'}}>
        <Typography variant="h6">
          {t('analytics:licensed_keys.filter')}
        </Typography>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            width: '100%',
          }}
        >
          <StartEndDatesComponent 
          values={{start_date: startDate, end_date: endDate}} 
          minDate={formatDate(minDate)}
          handleChangeStartDate={(e) => {formatSetDate(setStartDate, e)}}
          handleChangeEndDate={(e) => {formatSetDate(setEndDate, e)}}
           />
          <FormControl
            component="fieldset"
            style={{
              flex: 1,
              minWidth: 200,
            }}
          >
            <Select
              name="locality_uuid"
              options={localities}
              isMulti={false}
              cacheOptions
              defaultOptions
              selected={localityFilter.value}
              onChange={(o) => {
                setLocalityFilter(o)
                setLocalityUuid(o.value)

              }}
              placeholder={t('Весь фонд')}
              style={{ width: '100%' }}
            /> 

            <Select
              name="kind"
              options={kinds}
              isMulti={false}
              cacheOptions
              selected={kind}
              onChange={(o) => {
                setKind(o)
              }}
              placeholder={t('analytics:licensed_keys.kind_all')}
              style={{ width: '100%' }}
            /> 
          </FormControl>
        </div>
      </Wrapper>
      <TableContainer component={Wrapper}>
        <Table
          stickyHeader
          aria-label="simple table"
          style={{
            width: '100%',
            background: 'white',
            tableLayout: 'fixed',
          }}>
          <TableHead>
              <TableRow>
                <TableCell>
                  Кол-во ключей: {' '}
                  {keysSalesInfo?.meta?.total_count_no_filter}
                </TableCell>
                <TableCell>
                  Выручка: {' '}
                  {keysSalesInfo?.meta?.total_amount}
                </TableCell>
                <TableCell>{' '} </TableCell>
                <TableCell>{' '} </TableCell>
                <TableCell>{' '} </TableCell>
            </TableRow>
            <TableRow>
                <TableCell>
                  Дата Продажи
                </TableCell>
                <TableCell>
                  Номер Ключа
                </TableCell>
                <TableCell>
                  Сумма
                </TableCell>
                <TableCell>
                  Статус
                </TableCell>
                <TableCell>
                  Адрес
                </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {keysSalesInfo?.infos?.map((p) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={p.uuid}
                  style={{
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                >
                  <TableCell component="th" scope="row" padding="dense">
                    {visualFormatDate(p.created_at)}
                  </TableCell>
                  <TableCell component="th" scope="row" padding="dense">
                    {p.hex}
                  </TableCell>
                  <TableCell component="th" scope="row" padding="dense">
                    {p.price}
                  </TableCell>
                  <TableCell component="th" scope="row" padding="dense">
                    { displayState(p.blocked, p.deleted) }
                  </TableCell>
                  <TableCell component="th" scope="row" padding="dense">
                    {p.full_address}
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
                      
        </Table>
      </TableContainer>
      <TablePagination
        component={Wrapper}
        count={keysSalesInfo?.meta?.total_count || 0}
        rowsPerPage={limit}
        rowsPerPageOptions={[30, 50, 100]}
        page={page}
        labelRowsPerPage="Строк на странице:"
        onChangePage={(e, page) => {
          setPage(page)
        }}
        onChangeRowsPerPage={(e) => {
          setPage(1)
          setLimit(e.target.value)
        }}
        style={{ background: 'white' }}
      />
    </>
  )
}
